module.exports = __webpack_public_path__ + "static/media/gsinglepattern.b0c3d55e.png";